module.exports = __webpack_public_path__ + "img/tuvalu.a4079911.svg";